/* eslint-disable max-len */

import {NameValueMap} from '../../smart-shared/classes/KeyValueMap';

export const SMART_TABLE_DEFS: NameValueMap<any> = {};
